<template>
    <div class="card">
        <div class="card-header pr-0">
            <div class="d-flex justify-content-between align-items-center">
                {{ title }}
                <div class="text-right mr-3">
                    <slot name="extra-data"></slot>
                </div>
            </div>
        </div>
        <div class="text-center p-5" v-if="loading">
            <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Cargando...</span>
            </div>
        </div>
        <slot v-else ></slot>
    </div>
</template>

<script>
    export default {
        props: {
            title: {
                type: String,
                required: true
            },
            loading: {
                type: Boolean,
                default: false
            }
        }
    }
</script>